export default {
  home: '嗨',
  switchLang: 'English',
};
